import { useEffect, useState } from "react";
import { Input, Modal } from "antd";

export default function CreateFolderModal({ open, onClose, onCreate }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setError("");
      setSaving(false);
    }
  }, [open]);

  const handleOk = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Enter a folder name.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onCreate(trimmed);
    } catch (requestError) {
      setError(
        requestError?.response?.data?.error ||
          "Could not create the folder. Try again."
      );
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title="New folder"
      onCancel={saving ? undefined : onClose}
      onOk={handleOk}
      okText="Create"
      confirmLoading={saving}
      destroyOnHidden
    >
      <Input
        autoFocus
        placeholder="Folder name"
        value={name}
        onChange={(event) => {
          setName(event.target.value);
          setError("");
        }}
        onPressEnter={handleOk}
      />
      {error && (
        <div role="alert" style={{ marginTop: 10, color: "#b42318", fontSize: 13 }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
